import * as React from 'react';
import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';

import { Typography } from '../Typography';
import * as styles from './styles.css';

interface ICookieBannerProps {
  onAgreementClick: () => void;
  onClose: () => void;
  timerDurationMs?: number;
}

export const CookieBanner: React.FC<ICookieBannerProps> = ({ onAgreementClick, onClose, timerDurationMs }) => {
  return (
    <div className={styles['banner']}>
      <div className={styles['body']}>
        <div className={styles['text']}>
          <Typography.Text level={4}>Мы используем куки-файлы.&nbsp;</Typography.Text>

          <button type="button" className={styles['agreement']} onClick={onAgreementClick}>
            <Typography.Text level={4} color="link" fontWeight="bold">
              Соглашение об использовании
            </Typography.Text>
          </button>
        </div>

        <button type="button" className={styles['close']} onClick={onClose} aria-label="Закрыть">
          <IconActionClose12 color="icon-main-default" />
        </button>
      </div>

      {timerDurationMs !== undefined && (
        <div className={styles['timer']}>
          <div className={styles['timer-progress']} style={{ animationDuration: `${timerDurationMs}ms` }} />
        </div>
      )}
    </div>
  );
};

CookieBanner.displayName = 'CookieBanner';
